"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIScreenStatusValidation = void 0;
const ChargerUIScreenTypeValidation_1 = require("./ChargerUIScreenTypeValidation");
const InstructionalStepValidation_1 = require("./InstructionalStepValidation");
class ChargerUIScreenStatusValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // Validate entity.screen_type for existence and correct type.
        if (entity.screen_type == undefined)
            return false;
        if (!ChargerUIScreenTypeValidation_1.ChargerUIScreenTypeValidation.isValid(entity.screen_type))
            return false;
        // If entity.instructional_step exists, validate that it has the correct type.
        if (entity.instructional_step != undefined) {
            if (!InstructionalStepValidation_1.InstructionalStepValidation.isValid(entity.instructional_step))
                return false;
        }
        // If entity.possible_steps exists, validate that it has the correct type.
        if (entity.possible_steps != undefined) {
            if (!Array.isArray(entity.possible_steps))
                return false;
            if (!entity.possible_steps.every((elem) => {
                if (!InstructionalStepValidation_1.InstructionalStepValidation.isValid(elem))
                    return false;
                return true;
            }))
                return false;
        }
        return true;
    }
}
exports.ChargerUIScreenStatusValidation = ChargerUIScreenStatusValidation;
